var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: #fff;\n  display: inline-flex;\n  max-width: 100vw;\n  justify-content: flex-start;\n  align-items: center;\n  width: ', ';\n  transition: all 0.25s ease-in-out;\n\n  @media (max-width: 768px) {\n    max-width: 100% !important;\n  }\n\n  div.nowrap {\n    @media (max-width: 768px) {\n      width:100%;\n    }\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n\n  & > div:nth-child(2) {\n    margin: 0px;\n    max-width: 100%;\n  }\n\n  &:hover {\n    box-shadow: rgba(20, 20, 20, 0.1) 1px 1px 10px;\n    border-color: ', ';\n    @media (max-width: 768px) {\n      border: none;\n      border-color: transparent;\n      box-shadow: none;\n    }\n  }\n  &:focus {\n    border-color: ', ';\n    @media (max-width: 768px) {\n      border: none;\n      border-color: transparent;\n    }\n  }\n  label {\n    display: none;\n  }\n  .input-container {\n    width: 100%;\n    margin-left: 0px;\n    max-width: 100vw;\n  }\n  input {\n    margin: 0px;\n    background-color: transparent;\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n    @media (max-width: 768px) {\n      border-radius: ', ';\n      width: 100%;\n      margin-top: 4px;\n      margin-bottom: 4px;\n    }\n    &:focus, &.filled {\n      border-color: ', ';\n    }\n  }\n  button {\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n    min-width: 180px;\n    @media (max-width: 768px) {\n      margin-top: 4px;\n      border-radius: ', ';\n      min-width: 204px;\n      width: 100%;\n    }\n    &:hover {\n      transform: translateY(0px);\n    }\n  }\n'], ['\n  background-color: #fff;\n  display: inline-flex;\n  max-width: 100vw;\n  justify-content: flex-start;\n  align-items: center;\n  width: ', ';\n  transition: all 0.25s ease-in-out;\n\n  @media (max-width: 768px) {\n    max-width: 100% !important;\n  }\n\n  div.nowrap {\n    @media (max-width: 768px) {\n      width:100%;\n    }\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n\n  & > div:nth-child(2) {\n    margin: 0px;\n    max-width: 100%;\n  }\n\n  &:hover {\n    box-shadow: rgba(20, 20, 20, 0.1) 1px 1px 10px;\n    border-color: ', ';\n    @media (max-width: 768px) {\n      border: none;\n      border-color: transparent;\n      box-shadow: none;\n    }\n  }\n  &:focus {\n    border-color: ', ';\n    @media (max-width: 768px) {\n      border: none;\n      border-color: transparent;\n    }\n  }\n  label {\n    display: none;\n  }\n  .input-container {\n    width: 100%;\n    margin-left: 0px;\n    max-width: 100vw;\n  }\n  input {\n    margin: 0px;\n    background-color: transparent;\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n    @media (max-width: 768px) {\n      border-radius: ', ';\n      width: 100%;\n      margin-top: 4px;\n      margin-bottom: 4px;\n    }\n    &:focus, &.filled {\n      border-color: ', ';\n    }\n  }\n  button {\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n    min-width: 180px;\n    @media (max-width: 768px) {\n      margin-top: 4px;\n      border-radius: ', ';\n      min-width: 204px;\n      width: 100%;\n    }\n    &:hover {\n      transform: translateY(0px);\n    }\n  }\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component } from 'react';
import styled from 'styled-components';
import { Button, SmallPrimaryButton } from '../Button';
import InputText from '../InputText';
var InputButtonWrapper = styled.div(_templateObject, function (props) {
  return props.width || "100%";
}, function (props) {
  return props.theme.colours.primary.dark;
}, function (props) {
  return props.theme.colours.primary.dark;
}, function (props) {
  return props.theme.radius;
}, function (props) {
  return props.theme.colours.primary.dark;
}, function (props) {
  return props.theme.radius;
});

var InputButton = function (_Component) {
  _inherits(InputButton, _Component);

  function InputButton(props) {
    _classCallCheck(this, InputButton);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      filled: false
    };
    return _this;
  }

  InputButton.prototype.handleChange = function handleChange(e) {
    if (this.props.onChange) {
      this.props.onChange(e);
    }

    this.setState({
      filled: e.target.value ? true : false
    });
  };

  InputButton.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(InputButtonWrapper, {
      className: this.state.filled ? 'filled' : '',
      width: this.props.width
    }, React.createElement(InputText, _extends({
      onChange: function onChange(e) {
        _this2.handleChange(e);
      }
    }, this.props.input, {
      nowrap: true
    })), React.createElement(Button, this.props.button, this.props.children));
  };

  return InputButton;
}(Component);

export default InputButton;